<template>
  <div>
    <div class="block">
      <el-timeline>
        <el-timeline-item v-for="(log,index) in logList" :key="index" :timestamp="log.updateTime" placement="top">
          <el-card>
            <!--紧急通知显示红色-->
            <h4 v-if="log.title == '紧急通知：'" style="color: red">{{ log.title }}</h4>
            <h4 v-else>{{ log.title }}</h4>
            <p v-for="con in log.updateCon">{{con}}</p>
            <!--<el-image
               :style="log.imgStyle"
               v-for="imgUrl in log.imgUrls" :src="imgUrl"/>-->
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        logList: [ //倒叙
          {
            updateTime: '2025-12-02',
            title: '系统页面优化：',
            updateCon: ['许可证列表展示许可证的有效期限截止日期。']
          },
          {
            updateTime: '2024-08-28',
            title: '系统功能优化：',
            updateCon: ['许可证申请的附件模块优化。']
          },
          {
            updateTime: '2024-07-18',
            title: '系统功能优化：',
            updateCon: ['许可证导出内容新增有效期。']
          },
          {
            updateTime: '2024-05-17',
            title: '系统通知：',
            updateCon: ['为保障系统正常运行，计划本周末进行系统例行停机维护，预计停机时间2024-05-17 18:00至2024-05-20 12:00，给您造成不便，敬请谅解。']
          },
          {
            updateTime: '2024-03-11',
            title:'系统功能优化：',
            updateCon: ['所有涉及发送短信验证码前都需要进行验证（输入图形校验码）：忘记密码、注册以及修改手机号']
          },
          {
            updateTime: '2024-01-11',
            title:'系统功能优化：',
            updateCon: ['1.申请购买证、运输证或出入库报备业务，保存草稿时不做必填校验','2.许可证相关通知提醒新增删除功能']
          },
          {
            updateTime: '2023-11-23',
            title:'系统功能优化：',
            updateCon: ['申请购买证时，销售单位来源新增"国内港澳台"选项']
          },
          {
            updateTime: '2023-10-26',
            title:'系统功能优化：',
            updateCon: ['1.申请购买证时可以选择销售单位的企业来源','2.销售单位可以核查已核销的购买证','3.解决安卓13安装APP失败问题：软件包似乎无效，解析包时出现问题']
          },
          {
            updateTime: '2023-04-26',
            title:'系统数据更新：',
            updateCon: ['常见问题内容更新']
          },
          {
            updateTime: '2023-04-11',
            title:'系统功能优化：',
            updateCon: ['系统部分业务功能优化']
          },
          {
            updateTime: '2023-03-23',
            title:'系统功能优化：',
            updateCon: ['通知提醒优化']
          },
          {
            updateTime: '2023-03-14',
            title:'系统功能优化：',
            updateCon: ['增溢入库、损耗出库变更优化']
          },
          {
            updateTime: '2023-02-27',
            title:'系统功能优化：',
            updateCon: ['许可证核销模块变更']
          },
          {
            updateTime: '2023-01-04',
            title:'系统功能优化：',
            updateCon: ['出入库业务功能优化']
          },
          {
            updateTime: '2022-12-01',
            title:'系统功能优化：',
            updateCon: ['1.部分业务功能优化','2.多方运输证展示所有购买证']
          },
          {
            updateTime: '2022-10-27',
            title:'系统功能优化：',
            updateCon: ['1.从业人员编辑姓名优化;','2.统计报表-期末数量统计优化;']
          },
          {
            updateTime: '2022-09-30',
            title:'系统安全升级：',
            updateCon: ['1.管理员重置密码，默认密码规则已变更;','2.用户密码规则变化，简单密码需及时修改;']
          },
          {
            updateTime: '2022-09-08',
            title:'系统功能升级：',
            updateCon: ['1.许可证申请会校验相关资质，需对已过期或不完善的资质需要在单位信息变更中进行新增补充，涉及以下四类资质证件：非药品类易制毒化学品生产许可证、非药品类易制毒化学品经营许可证、非药品类易制毒化学品经营备案证明、非药品类易制毒化学品生产备案证明;'
            ,'2.责任书限制开启，若不存在有效的责任书会影响办理业务（即未过期的已提交或已签订状态的责任书是有效的责任书），请及时上传新的责任书，提交后重新登录即可;'
            ],
            // imgStyle:'width: 30%;  padding-right: 10px;', //图片样式
            // imgUrls:[require('../assets/img/check1.png'),require('../assets/img/check1.png')] //图片示例
          }
        ]
      }
    }
  }
</script>

<style>

</style>
